
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.wrapper{
  outline:var(--color-primary-default) solid 1px;
  border-radius:10px;
  overflow:hidden;
}
  @media print{.wrapper{
    outline:var(--color-neutral-white) solid 1px;
    break-inside:avoid
}
  }

.header{
  display:flex;
  grid-column-gap:4rem;
  grid-row-gap:0px;
  align-items:center;
  justify-content:space-between;
  background-color:var(--color-primary-lightest);
  padding:var(--spacing-04);
}

@media print{

.header{
    background-color:var(--color-neutral-white);
    padding:var(--spacing-02);
    padding-right:var(--spacing-56)
}
  }

.rate-table{
  overflow:scroll;
  max-width:100%;
}

@media (min-width: 640px){

.rate-table{
    overflow:auto
}
  }

.page-date{
  justify-content:flex-end;
  display:grid;
}

@media print{

.page-date{
    font-size:calc(100% * 0.5)
}
  }

.disclaimer{
  --sic-text-color:var(--color-neutral-dark);
  background-color:var(--color-neutral-lightest);
  padding:var(--spacing-04);
}

@media print{

.disclaimer{
    background-color:var(--color-neutral-white);
    padding:var(--spacing-02);
    break-before:avoid
}
  }

[cloned-slot-name='table-heading'] a{
    color:var(--color-neutral-dark);
  }

@media print{

[cloned-slot-name='table-heading'] a sic-heading{
        font-size:calc(var(--headline-01-font-size) * 0.75)
    }
      }

@media print{

[cloned-slot-name='disclaimer'] sic-styled-disclaimer-text *{
        font-size:calc(var(--body-helper-min-font-size) * 0.5)
    }
      }
`;